import moment from 'moment';

const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';

export function formatSubscriptionDate(value?: string | null): string | null {
    if (!value) return null;

    const date = moment.utc(value, moment.ISO_8601, true);
    if (!date.isValid()) return null;

    return date.local().format(DISPLAY_DATE_FORMAT);
}

export function formatSubscriptionPrice(unitAmount?: number | null, currency?: string | null): string | null {
    if (unitAmount == null || !Number.isFinite(unitAmount) || !currency) {
        return null;
    }

    const normalizedCurrency = currency.trim().toUpperCase();
    if (!normalizedCurrency) return null;

    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: normalizedCurrency
        }).format(unitAmount);
    } catch {
        return `${unitAmount} ${normalizedCurrency}`;
    }
}